<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="400"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="navigation-head">
            <span>{{ titleForm }}</span>                         
        </div>

        <div class="pl-3 pt-3 pr-3" style="height: 80vh;">                
            <template>
                <!--
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete
                            ref="company_id"
                            v-model="officeForm.company_id"
                            :items="companies"
                            label="Seleccione empresa"                            
                            outlined
                            :item-text="customText"
                            item-value="id"
                            clearable
                            :rules="[() => !!officeForm.company_id || 'Es necesario seleccionar una empresa']"
                            hide-details="auto"
                            required
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                -->
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            ref="name"
                            v-model="officeForm.name" 
                            label="Nombre"
                            outlined 
                            :rules="[() => !!officeForm.name || 'Es necesario ingresar un nombre']"
                            hide-details="auto"
                            required
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="officeForm.phone" label="Teléfono" outlined hide-details></v-text-field>
                    </v-col>
                </v-row>                
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="officeForm.address"
                            outlined
                            label="Dirección"
                            >
                        </v-textarea>
                    </v-col>
                </v-row>                   
            </template>                    
        </div>

        <div class="mt-3 pl-3 pt-3 pr-3">
            <template>
                <v-row>
                    <v-col cols="6">
                        <v-btn block height="40" dark color="red" @click="handleCancel">
                            <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
                            Cancelar
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn v-if="action == 'create'" dark color="success" block height="40" @click="handleStore">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Guardar
                        </v-btn>
                        <v-btn v-if="action == 'update'" dark color="success" block height="40" @click="handleUpdate">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Actualizar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>               
            
        </div>

    </v-navigation-drawer>
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
    name: 'CreateUpdate',
    data() {
        return {
            drawer: false,
            titleForm: null,
            action: null,
            officeForm: {
                id: null,
                name: null,
                company_id: null,
                sede_id: null,
                address: null,
                phone: null
            }
        }
    },
    computed: {
        ...mapState('companies', [
            'companies'
        ]),
        ...mapState('sedes', [
            'sedes'
        ])
    },
    methods: {
        ...mapActions('sedes', [
            'getSedes'
        ]),
        ...mapActions('offices', [
            'store',
            'update'
        ]),
        async showForm(title, action, office = null) {
            await this.clearData();
            this.titleForm = title
            this.action = action
            this.selectCompany();
            if (office) {
                this.setOffice(office)
            }
            this.drawer = !this.drawer
        },
        clearData() {
            this.titleForm = null
            this.action = null
            this.officeForm.id = null
            this.officeForm.name = null
            this.officeForm.phone = null
            this.officeForm.address = null
            this.officeForm.sede_id = null
            this.officeForm.company_id = null;
            this.clearErrors();
        },
        setOffice(office) {
            this.officeForm.id = office.id
            this.officeForm.name = office.name
            this.officeForm.phone = office.phone
            this.officeForm.address = office.address
            this.officeForm.sede_id = office.sede_id
            this.officeForm.company_id = office.company_id;
        },
        customText(item){
            let text = item.name
            
            return text
        },
        closeForm() {
            this.clearData()
            this.drawer = false
        },
        handleCancel() {
            this.closeForm()
        },
        async handleStore() {
            if(!this.existErrors()){
                await this.store(this.officeForm)
                this.closeForm()
            }            
        },
        async handleUpdate() {
            if(!this.existErrors()){
                await this.update(this.officeForm)
                this.closeForm()
            }            
        },
        existErrors(){
            let hasErrors = false;

            Object.keys(this.officeForm).forEach(f => {                
                if (this.$refs[f]) {
                    if (!this.officeForm[f]) hasErrors = true
                    this.$refs[f].validate(true);
                }                
            });

            return hasErrors;
        },
        clearErrors() {
            Object.keys(this.officeForm).forEach(f => {
                if (this.$refs[f]) this.$refs[f].reset()                
            });
        },
        selectCompany () {
            if (this.companies.length == 1) {
                this.officeForm.company_id = this.companies[0].id;
            }
        }
    }
}
</script>

<style scoped>

</style>